import React from 'react'

export default function ServiceComplianceBadge({ serviceCompliance }) {
  if (!serviceCompliance) return null

  const overdueItems = serviceCompliance.filter((s) => s.overdue)
  const isCompliant = overdueItems.length === 0

  return (
    <div className={`border-[1.5px] bg-surface p-4 mb-6 ${isCompliant ? 'border-ink' : 'border-accent'}`}>
      <div className="flex items-center gap-2">
        {isCompliant ? (
          <>
            <svg className="w-5 h-5 text-ink" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <span className="font-bold text-ink">All services on schedule</span>
          </>
        ) : (
          <>
            <span className="bg-accent text-white text-[11px] font-extrabold tracking-widest px-2 py-0.5">OVERDUE</span>
            <span className="font-bold text-ink">{overdueItems.length} service{overdueItems.length !== 1 ? 's' : ''} past due</span>
          </>
        )}
      </div>
      {overdueItems.length > 0 && (
        <ul className="mt-2 space-y-1">
          {overdueItems.map((item, i) => (
            <li key={i} className="text-sm text-muted">{item.title}</li>
          ))}
        </ul>
      )}
    </div>
  )
}
